'use strict';

var $ = require('js/sw-jquery/sw-jquery');

/**
 * Turns a regularly placed element into a sticky element (when the element is scrolled to,
 * it will stick to the top of the page).
 *
 * Usage:
 *
 * data-sw-sticky-element
 *   Put this on the element you want to be sticky.
 *
 * data-sw-sticky-element-z-index=<number>
 *   Determines the z-index of the element.
 *
 * data-sw-sticky-element-top-spacing=<number>
 *   Determines the spacing in pixels from the top during the scroll.
 *
 * data-sw-sticky-element-wrapper-class=<string>
 *   Adds a class to the sticky wrapper.
 *
 * @param $fragment
 */
module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-sticky-element]').each(function() {
    var $el = $(this);

    var widthOverride = $el.data('swStickyElementWidthOverride');

    var options = {
      zIndex: $el.data('swStickyElementZIndex'),
      topSpacing: $el.data('swStickyElementTopSpacing'),
      wrapperClassName: $el.data('swStickyElementWrapperClass'),
      className: $el.data('swStickyElementStickyClass'),
      widthFromWrapper: widthOverride ? false : true
    };

    $el.sticky(options);

    $el.attr('data-sw-sticky-element-loaded', true);
  });

};
